import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTestResultIconModule } from '../data-test-result-icon/data-test-result-icon.module';
import { DataTestLatestJobStatusCellRendererComponent } from './data-test-latest-job-status-cell-renderer.component';

@NgModule({
  declarations: [DataTestLatestJobStatusCellRendererComponent],
  imports: [CommonModule, DataTestResultIconModule],
  exports: [DataTestLatestJobStatusCellRendererComponent],
})
export class DataTestLatestJobStatusCellRendererModule {}
